import { GlobalState } from '@store';

import { FILTERS_NAME } from '@constants/filters';

export const getFilters = (state: GlobalState) => state.filters.filters;
export const getOneFilter = (filterName: FILTERS_NAME) => (state: GlobalState) => state.filters.filters?.[filterName];
